import React from 'react';
import '../Pages.css';

function TechnologySupport() {
  return (
    <div className='page'>
      <h1>Technology Support</h1>
      <p id='tech-text'>We are visually impaired people with lived experience in using technology with accessibility features. We may not be officially Apple/Android geniuses but we know our way around using tech. We can help you become independent and confident with everyday technology.</p>
      <div class='offer-list'>
        <ul>
          <h3>We can help you with:</h3>
          <li>Text sizing</li>
          <li>Magnifiers</li>
          <li>Screen readers</li>
          <li>Adjusting contrast</li>
          <li>Using websites</li>
          <li>Navigating the internet</li>
          <li>Texting</li>
          <li>E-Mail</li>
          <li>Useful apps</li>
        </ul>
      </div>
    </div>
  )
}

export default TechnologySupport